import React, { Suspense, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import ConfigProvider from '../../providers/Config/Provider'
// import CssBaseline from '@mui/material/CssBaseline';  // im LayoutContainer verankert...
//import { CookieBanner } from "../../../../components/react-cookie-law"
const Layout = lazy(() => import('../../containers/Layout/Layout'))


const App = ({ config: appConfig }) => {
  const config = { ...appConfig }
  const { pages, components, containers } = config
  const { LandingPage = false } = pages || {}
  const { Loading = () => <div /> } = components || {}
  const { AppContainer = React.Fragment } = containers || {}
 
  const PUBLIC_URL = process.env.PUBLIC_URL
  //console.log("PUBLIC_URL: " + PUBLIC_URL)
  return (
    <Suspense fallback={<Loading />}>
      <ConfigProvider appConfig={config}>
        <AppContainer>
          <BrowserRouter basename={PUBLIC_URL}>
          
            <Routes>
              {LandingPage && (
                <Route path="/" exact element={<LandingPage />} />
              )}
              <Route
                path="*"
                element={
                  <Suspense fallback={<Loading />}>
                    <Layout appConfig={config} />
                  </Suspense>
                }
              />
            </Routes>
          </BrowserRouter>
        </AppContainer>
      </ConfigProvider>
    </Suspense>
  )
}

export default App
